/**
 * listNameUtils.ts
 *
 * Returns a SharePoint list (or SQL table) name with the project-code prefix
 * prepended.  The prefix is injected at build time via the REACT_APP_PROJECT_CODE
 * environment variable, which is populated from the projectCode the user entered
 * in the RhyBus extension before the code was pushed to the repo.
 *
 * Example:
 *   REACT_APP_PROJECT_CODE=ACQ
 *   getListName('Requirements')  →  'ACQ_Requirements'
 *   getListName('ACQ_Requirements')  →  'ACQ_Requirements'  (idempotent — won't double-prefix)
 */
declare const process: { env: { REACT_APP_PROJECT_CODE?: string } }

export function getListName(baseName: string): string {
  const prefix = (process.env.REACT_APP_PROJECT_CODE ?? '').trim().toUpperCase()
  
  if (!prefix) return baseName

  // Idempotent: don't add the prefix a second time if it's already there
  const expectedStart = `${prefix}_`
  if (baseName.toUpperCase().startsWith(expectedStart)) return baseName

  return `${prefix}_${baseName}`
}
